<template>
  <div class="route-stops-animation">
    <svg viewBox="0 0 64 18" width="64" height="18">
      <path d="M6 9 H58" stroke="#d3d8dd" stroke-width="2" stroke-linecap="round" fill="none"/>
      <circle class="rs-stop" cx="12" cy="9" r="3"/>
      <circle class="rs-stop rs-stop-2" cx="32" cy="9" r="3"/>
      <circle class="rs-stop rs-stop-3" cx="52" cy="9" r="3"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'RouteStopsAnimation'
}
</script>

<style scoped>
.route-stops-animation {
  display: flex;
  align-items: center;
}

.route-stops-animation svg {
  display: block;
  overflow: visible;
}

/* stops light up in sequence, like a bus working its way down the route */
.rs-stop {
  fill: #b9c1c9;
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation: rs-ping 1.8s ease-in-out infinite;
}

.rs-stop-2 {
  animation-delay: 0.3s;
}

.rs-stop-3 {
  animation-delay: 0.6s;
}

@keyframes rs-ping {
  0%, 50%, 100% {
    fill: #b9c1c9;
    transform: scale(1);
  }
  15% {
    fill: #1976D2;
    transform: scale(1.4);
  }
}

@media (prefers-reduced-motion: reduce) {
  .rs-stop {
    animation: none !important;
  }
}
</style>
